import { UseMutationOptions, UseMutationResult } from 'react-query';
import { PaymentPlanQueries } from '@frontend/api-payment-plans';
import { PersonsV3 } from '@frontend/api-person';
import { PaymentMethodsBaseApiMethods } from '../types/api.types';
import { DeleteMethodOptions } from './use-delete-payment-method';

export type UsePaymentMethodsJustifiApiProps = {
  isPublic?: boolean;
};

export type PaymentMethodsJustifiApi = PaymentMethodsBaseApiMethods;

export const usePaymentMethodsJustifiApi = ({
  isPublic,
}: UsePaymentMethodsJustifiApiProps): PaymentMethodsJustifiApi => {
  const getPublicImplementation = (): PaymentMethodsJustifiApi => {
    return {
      usePaymentPlansInvalidation: () => {
        console.warn('unimplemented method');
        return {
          invalidatePaymentMethodsByPerson: () => {},
        };
      },
      useDeletePaymentMethod: (_options: UseMutationOptions<unknown, unknown, DeleteMethodOptions>) => {
        console.warn('unimplemented method');
        return {} as UseMutationResult<
          unknown,
          unknown,
          {
            paymentMethodId: string;
            locationId: string;
          },
          unknown
        >;
      },
      useGetPaymentMethodsByPerson: () => {
        console.warn('unimplemented method');
        return {
          data: undefined,
          isLoading: false,
          isError: false,
          error: null,
        } as any;
      },
      useQueryLegacyPerson: () => {
        console.warn('unimplemented method');
        return {
          data: undefined,
          isLoading: false,
          isError: false,
          error: null,
        } as any;
      },
    };
  };

  const getAuthenticatedImplementation = (): PaymentMethodsJustifiApi => {
    return {
      usePaymentPlansInvalidation: PaymentPlanQueries.usePaymentPlansInvalidation,
      useDeletePaymentMethod: PaymentPlanQueries.useDeletePaymentMethod,
      useGetPaymentMethodsByPerson: PaymentPlanQueries.useGetPaymentMethodsByPerson,
      useQueryLegacyPerson: ({
        locationId,
        personId,
      }: {
        locationId: string | undefined;
        personId: string | undefined;
      }) => {
        return PersonsV3.PersonQueries.useGetPersonLegacyQuery(
          { locationIds: [locationId ?? ''], personId: personId ?? '' },
          { enabled: !!personId }
        );
      },
    };
  };
  return isPublic ? getPublicImplementation() : getAuthenticatedImplementation();
};
